<!--  -->
<template>
  <div class="put-status column-flex" v-if="show">
    <img :src="require('@/assets/' + icon + '.png')" />
    <p>{{ msg }}</p>
    <small>{{ info }}</small>
    <div class="btn" v-if="hasBtn" @click="toPage">去任务中心查看</div>
  </div>
</template>

<script>
export default {
  name: "put-status",
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    hasBtn: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "task-check",
    },
    msg: {
      type: String,
      default: "审核中...",
    },
    info: {
      type: String,
      default: "审核通过后可在58App服务号或58问卷任务中心查看",
    },
  },
  methods: {
    toPage() {
      this.$router.push("/home/taskCenter");
    },
  },
};
</script>
<style lang='scss' scoped>
.put-status {
  align-items: center;
  padding-bottom: 66px;
  img {
    width: 120px;
    height: 120px;
    margin-bottom: 25px;
  }
  p {
    font-size: 24px;
    color: #333;
    height: 33px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    line-height: 33px;
    margin-bottom: 7px;
  }
  small {
    height: 20px;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #999;
  }
  .btn {
    text-align: center;
    margin-top: 36px;
    margin-bottom: 60px;
    height: 36px;
    line-height: 36px;
    color: #fff;
    padding: 0;
    width: 142px;
    background-color: rgba(255, 85, 45, 1);
    border-radius: 2px;
    cursor: pointer;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/shareCommon/put-status.vue